(function () {
  function init() {
    var data = document.querySelector('.ki-tee-data');
    if (!data) return;
    var ki = (data.getAttribute('data-ki') || '').trim();
    if (!ki) return;
    var mod = 'ki-label--' + ki.toLowerCase().replace(/\s+/g, '-');

    function inject() {
      document.querySelectorAll('.tee-slide .tee-mockup-item').forEach(function (item) {
        if (item.querySelector('.ki-label')) return;      // nicht doppelt
        var span = document.createElement('span');
        span.className = 'ki-label ' + mod;
        span.setAttribute('title', ki);
        span.textContent = ki;
        item.appendChild(span);
      });
    }

    inject();
    // teeinblue rendert bei Änderungen neu -> Label erneut setzen
    var root = document.querySelector('.tee-gallery') || document.body;
    new MutationObserver(function () { inject(); }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();